export function getDaysInMonth(year, month) {
    const daysInMonth = new Date(year, month, 0).getDate();
    const daysArray = Array.from({ length: daysInMonth }, (_, index) => index + 1);
    return daysArray;
}